module.exports = __webpack_public_path__ + "static/media/bathroom_1.2e5f1629.jpg";